import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const LANGS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === (i18n.language || "en").split("-")[0]) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher-trigger"
          className="inline-flex items-center gap-2 px-3 py-2 text-xs font-mono-spec border border-slate-700 text-slate-300 hover:text-white hover:border-amber-400 transition-colors rounded-sm"
        >
          <Globe size={14} />
          <span>{current.code.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-slate-950 border border-slate-800 text-slate-200"
      >
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => i18n.changeLanguage(l.code)}
            className="cursor-pointer focus:bg-slate-800 focus:text-white"
          >
            <span className="font-mono-spec text-xs mr-3 text-amber-400">{l.code.toUpperCase()}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
